export default [
  {
    questionId: 'qid_postcode',
    slug: 'postcode',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: "What's your main business address?",
    subtitle: 'We know VoIP can be across multiple locations - we just need your main address to get our search started',
    type: 'postcode',
    autoprogress: true
  },

  {
    questionId: 'qid_voip_user',
    slug: 'voip-user',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'Are you an existing VoIP user?',
    subtitle: 'This will help us to tailor your package.',
    type: 'services',
    inlineNextButton: true
  },

  {
    questionId: 'qid_current_supplier',
    slug: 'supplier',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'Who is your current broadband provider?',
    subtitle: 'This will help us to ensure you have a reliable broadband connection.',
    type: 'supplier',
    inlineNextButton: true
  },

  {
    questionId: 'qid_voip_features',
    slug: 'voip-features',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'What VoIP features are you looking for?',
    subtitle: 'This will help us tailor a solution to suit your needs.',
    type: 'checklist',
    layout: 'grid',
    options: [
      {
        label: 'Inclusive calls',
        value: 'inclusive-calls',
        tooltip: 'Make calls to landlines and mobiles for free as part of your plan'
      },
      {
        label: 'Remote working',
        value: 'remote-working',
        tooltip: 'Take calls wherever you are e.g. at work, at home or on the go'
      },
      {
        label: 'Virtual receptionist',
        value: 'virtual-receptionist',
        tooltip: 'Automatically redirect calls you cannot answer'
      },
      {
        label: 'Smart call routing',
        value: 'smart-call-routing',
        tooltip: 'Increase efficiency and call management to improve your customer experience'
      },
      {
        label: 'Mobile app',
        value: 'mobile-app',
        tooltip: 'Access your phone system using your smart phone, tablet or other portable device anytime and anywhere'
      },
      {
        label: 'Scalability',
        value: 'scalability',
        tooltip: 'Seamlessly add new users and new locations to your phone system'
      },
      {
        label: 'Call recording/call logging',
        value: 'call-recording-call-logging',
        tooltip: 'Access calls and customer insights saved automatically in the cloud'
      },
      {
        label: 'Other/No preference',
        value: 'other-no-preference'
      }
    ],
    message: {
      type: 'single',
      config: {
        value: 'Great, our experts will tailor a package to include these features'
      }
    }
  },

  {
    questionId: 'qid_how_many_users',
    slug: 'how-many-users',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'How many phone users do you have?',
    subtitle: 'This will help us understand your usage requirements - a quick estimate is fine for now.',
    type: 'radiolist',
    layout: 'grid',
    options: [
      {
        label: '1-3 users',
        value: '1-3'
      },
      {
        label: '4-8 users',
        value: '4-8'
      },
      {
        label: '9-14 users',
        value: '9-14'
      },
      {
        label: '15+ users',
        value: '15+'
      }
    ],
    message: {
      type: 'single',
      config: {
        value: 'Thank you. We will help you find the best solution to simplify call management for your users'
      }
    }
  },

  {
    questionId: 'qid_locations',
    slug: 'locations',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'Do you work from multiple locations?',
    subtitle: 'This will help us tailor a solution to suit your needs.',
    type: 'radiolist',
    layout: 'grid',
    options: [
      {
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }
    ],
    message: {
      type: 'map',
      config: [
        {
          results: ['yes'],
          value: "Perfect, we'll build a solution to keep all your locations connected"
        },
        {
          results: ['no'],
          value: 'OK, that keeps it simple!'
        }
      ]
    }
  },
  {
    questionId: 'qid_voip_kit',
    slug: 'voip-kit',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'Lastly, how do you want to use your VoIP system?',
    subtitle: 'This will help us offer the most bespoke solution for you.',
    type: 'checklist',
    layout: 'grid',
    options: [
      {
        label: 'With handsets',
        value: 'handsets'
      },
      {
        label: 'Mobile app',
        value: 'mobile-app'
      },
      {
        label: 'Through desktop/PC',
        value: 'pc'
      },
      {
        label: 'Other',
        value: 'other'
      }
    ],
    message: {
      type: 'map',
      config: [
        {
          results: ['handsets', 'mobile-app', 'pc'],
          value: 'Great, our experts will take this into account and tailor your package.'
        },
        {
          results: ['other'],
          value: 'No problem, we can run through your options with you.'
        }
      ]
    }
  }
]
